import React from 'react';
import CardLogo from 'components/pages/checkout/payment/saved_cards/card_logo';
import { MarketActionCard } from '@market/react';
import { Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';

const SelectedSavedCard = ({
  selectedCard = null,
  usePostalCode = false,
  onCardClicked,
}) => {
  if (selectedCard === null) {
    return null;
  }

  const styles = {
    selectedCard: {
      height: '64px',
      display: 'flex',
      alignItems: 'center',
      padding: '0px 12px 0px 16px',
      marginBottom: selectedCard.default ? '40px' : '23px',
    },
    gridContainer: {
      alignItems: 'center',
    },
    cardNumberSection: {
      paddingLeft: '10px',
    },
  };

  const { t } = useTranslation();

  return (
    <MarketActionCard
      style={styles.selectedCard}
      onMarketCardDeselected={onCardClicked}
      selected=""
      data-testid="selected-saved-card"
    >
      <Grid container style={styles.gridContainer}>
        <Grid item xs={1}>
          <CardLogo brand={selectedCard.payment_source.brand} />
        </Grid>
        <Grid item xs={5} style={styles.cardNumberSection}>
          <p className="semibold-20">
            {t('checkout.payment.selectedCard.cardNumber')}
          </p>
          <p className="paragraph-30">
            •••• •••• •••• {selectedCard.payment_source.last_digits}
          </p>
        </Grid>
        <Grid item xs={usePostalCode ? 2 : 3}>
          <p className="semibold-20">
            {t('checkout.payment.selectedCard.expiration')}
          </p>
          <p className="paragraph-30">
            {selectedCard.payment_source.month}/
            {selectedCard.payment_source.year}
          </p>
        </Grid>
        <Grid item xs={usePostalCode ? 2 : 3}>
          <p className="semibold-20">
            {t('checkout.payment.selectedCard.cvv')}
          </p>
          <p className="paragraph-30">•••</p>
        </Grid>
        {usePostalCode && (
          <Grid item xs={2}>
            <p className="semibold-20">ZIP</p>
            <p className="paragraph-30">
              {selectedCard.payment_source.postal_code.trim().split('-')[0]}
            </p>
          </Grid>
        )}
      </Grid>
    </MarketActionCard>
  );
};

export default SelectedSavedCard;
